const DETAIL_ROUTE_PATTERNS = [
  /^\/destination\/[^/]+$/,
  /^\/stays-camps\/[^/]+\/[^/]+$/,
  /^\/experiences\/[^/]+\/[^/]+$/,
  /^\/jungle-safaris\/[^/]+\/[^/]+$/,
  /^\/cruise-boating\/[^/]+\/[^/]+$/,
  /^\/treks-trails\/[^/]+$/,
  /^\/treks-trails\/[^/]+\/[^/]+$/,
  /^\/track-trails\/[^/]+$/,
  /^\/track-trails\/[^/]+\/[^/]+$/,
];

const normalizePathname = (value = "/") => {
  const pathname = String(value || "/")
    .split(/[?#]/, 1)[0]
    .trim();
  if (!pathname || pathname === "/") return "/";
  const withLeadingSlash = pathname.startsWith("/") ? pathname : `/${pathname}`;
  return withLeadingSlash.replace(/\/+$/, "") || "/";
};

export const isDetailPerformanceRoute = (pathname = "/") => {
  const normalizedPath = normalizePathname(pathname);
  return DETAIL_ROUTE_PATTERNS.some((pattern) => pattern.test(normalizedPath));
};

export { normalizePathname as normalizeDetailRoutePathname };
